import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Maximize2, ArrowRight } from 'lucide-react';

const VerticalCarousel = ({ onImageClick }) => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const res = await axios.get('/api/home-visualizer');
                setImages(res.data);
            } catch (error) {
                console.error('Home visualizer images fetch error:', error);
            }
        };
        fetchImages();
    }, []);

    if (images.length === 0) return null;

    return (
        <div className="hidden lg:flex flex-col gap-6 w-24 h-full py-10 items-center overflow-y-auto no-scrollbar mask-image-vertical">
            <div className="rotate-90 text-xs font-bold tracking-[0.3em] text-white/50 whitespace-nowrap mb-10 origin-center">
                ODANI CANLANDIR
            </div>
            {images.map((img, i) => (
                <div
                    key={i}
                    onClick={() => onImageClick && onImageClick(i)}
                    className="group relative w-16 h-24 rounded-2xl overflow-hidden cursor-pointer shadow-lg hover:scale-110 transition-transform duration-300 border border-white/20"
                >
                    <img src={img.url} alt="Inspiration" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-maximize2 w-5 h-5 text-white">
                            <polyline points="15 3 21 3 21 9"></polyline>
                            <polyline points="9 21 3 21 3 15"></polyline>
                            <line x1="21" x2="14" y1="3" y2="10"></line>
                            <line x1="3" x2="10" y1="21" y2="14"></line>
                        </svg>
                    </div>
                </div>
            ))}
            <div className="mt-auto w-10 h-10 rounded-full border border-white/30 flex items-center justify-center text-white/50 hover:bg-white/20 hover:text-white transition-colors cursor-pointer">
                <ArrowRight className="w-4 h-4 rotate-90" />
            </div>
        </div>
    );
};

export default VerticalCarousel;
